export class IBLRouteDefs {
  public static FEATURE_PATH = "ibl";
}
